<template>
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -->
    <div
        v-if="isMasquerading"
        ref="bannerEl"
        class="fixed z-[9999] flex items-center gap-2 rounded-full bg-button-danger shadow-lg select-none whitespace-nowrap"
        :class="[isDragging ? 'cursor-grabbing' : 'cursor-grab', isPositioned ? '' : 'bottom-4 left-4']"
        :style="dragStyle"
        @mousedown="onPointerDown"
        @touchstart="onPointerDown">
        <div class="pl-2 py-2 text-white/70 hover:text-white" aria-hidden="true">
            <i class="bi bi-grip-vertical text-sm" aria-hidden="true"></i>
        </div>
        <form method="post" :action="masqueradeEndUrl">
            <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
            <button type="submit" class="bg-button-danger hover:bg-button-danger-hover text-white body-small-semibold pl-1 pr-4 py-2 rounded-full transition-colors">
                {{ t("components.masqueradeBanner.exitDemoMode") }}
            </button>
        </form>
    </div>
</template>

<script setup lang="ts">
import { getCookie } from "/js/utils";
import { usePage } from "@inertiajs/vue3";
import { useDraggable } from "~vue/composables/useDraggable";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface MasqueradePageProps {
    is_masquerading?: boolean;
    masquerade_end_url?: string;
    [key: string]: unknown;
}

const page = usePage<MasqueradePageProps>();
const isMasquerading = computed(() => page.props.is_masquerading);
const masqueradeEndUrl = computed(() => page.props.masquerade_end_url);
const csrfToken = getCookie("csrftoken");

const {
    elRef: bannerEl,
    style: dragStyle,
    onPointerDown,
    isDragging,
    isPositioned,
} = useDraggable({
    storageKey: "masquerade-banner-position",
    snapMode: "corner",
    zIndex: 9999,
});
</script>
